import RestAPI from '../../Common/restApi';

export default class ProgressiveApi {
  static updateDemoBooked() {
    return RestAPI.updateWithFormData('/alpha/onboarding/demos', {});
  }

  static canBookDemo() {
    return RestAPI.get('/alpha/onboarding/demos/can_book_demo');
  }
}
